import { Component, OnInit } from "@angular/core";
import { Validators, FormBuilder } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastService } from "ng-uikit-pro-standard";
import { AppConfig } from "src/app/config";
import { DataService } from "src/app/data.service";
import { GUID } from "src/app/guid";

@Component({
  selector: "app-crudmessagenew",
  templateUrl: "./crudmessagenew.component.html",
  styleUrls: ["./crudmessagenew.component.scss"],
})
export class CrudmessagenewComponent implements OnInit {
  isLoading = false;
  isError = false;
  errorMessage = "";
  id = "";
  mode = "New";
  messageCategories: any[];
  crudMessage: any;
  crudMessageId = "";
  guid: GUID;

  actionForm = this.formBuilder.group({
    language: ["en"],
    messagecategory: [""],
    type: [""],
    message: ["", Validators.required],
    name: ["", Validators.required],
    description: [""],
    active: [false],
    successmessage: [""],
  });

  languages = [
    { value: "en", label: "English" },
    { value: "ta", label: "Tamil" },
    { value: "ar", label: "Arabic" },
  ];
  types = [
    { value: "common", label: "Common" },
    { value: "tenant", label: "Tenant" },
  ];
  messageCategoriess = [
    { value: "create", label: "Create" },
    { value: "update", label: "Update" },
    { value: "patch", label: "Patch" },
    { value: "changeowner", label: "Change Owner" },
    { value: "delete", label: "Delete" },
    { value: "harddelete", label: "Hard Delete" },
    { value: "edge", label: "Edge" },
    { value: "multiplerecord", label: "Multiple Record" },
    { value: "bulkcreate", label: "Bulk Create" },
    { value: "mastercreate", label: "Master Create" },
    { value: "nestedcreate", label: "Nested Create" },
    { value: "masterupdate", label: "Master Update" },
    { value: "nestedupdate", label: "Nested Update" },
    { value: "bulkupdate", label: "Bulk Update" },
    { value: "bulkpatch", label: "Bulk Patch" },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastService,
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private appConfig: AppConfig
  ) {}

  ngOnInit() {
    this.guid = new GUID();

    this.route.queryParams.subscribe((params) => {
      // this.mode = this.route.snapshot.params.mode;
      this.mode = this.route.snapshot.params.mode;

      this.crudMessageId = this.route.snapshot.params.id;
    });
    this.getAllMessageCategory();

    if (this.mode.toLocaleLowerCase() == "edit") {
      this.getCrudMessageById();
    }
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  cancel() {
    this.router.navigateByUrl("home/crudmessagelist");
  }

  getAllMessageCategory() {
    return new Promise((resolve, reject) => {
      console.log("getAllMessageCategory");

      // alert(id)
      const organizationid = localStorage.getItem("crm_orgid");
      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      this.isLoading = true;
      this.dataService.getAllMessageCategory(domain, subdomain).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            var msgCategories = res.data.crudmessagecategory;
            var categoryArr = [];
            //just add an empty entry sice this field is optional
            // categoryArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < msgCategories.length; i++) {
              var strLabel = msgCategories[i].operation;
              strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);

              categoryArr.push({
                value: msgCategories[i].id,
                label: strLabel,
              });
            }
            this.messageCategories = categoryArr;

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No data!");
            this.errorMessage =
              res != null ? res.message : "No data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getCrudMessageById() {
    return new Promise((resolve, reject) => {
      console.log("getcrudmessages");

      // alert(id)
      const id = this.crudMessageId;
      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      this.isLoading = true;
      this.dataService.getCrudMessageById(domain, subdomain, id).subscribe(
        (res) => {
          console.log("res", res);

          if (res.success == 1) {
            this.crudMessage = res.data.crudmessage[0];
            console.log("Doneeee****", this.crudMessage);

            if (this.crudMessage != null) {
              // this.dataSource = this.crudmessages.map((item) => ({
              //   id: item.id,
              //   // label: item.labelname,
              //   message: item.message,
              //   operation: item.operation.charAt(0).toUpperCase() + item.operation.slice(1),
              //   language: item.languagecode,
              //   // modifiedby: item.modifiedby,
              //   // modifieddate: item.modifieddate,
              //   // type: item.organizationid,
              //   // type: item.organizationid ? item.organizationid : 'common',
              //   type: item.organizationid ? 'Tenant' : 'Common',
              //   // content: item.content,
              //   // metalayoutid: item.metalayoutid,
              // }));
              this.actionForm.controls["message"].setValue(
                this.crudMessage.message
              );
              this.actionForm.controls["language"].setValue(
                this.crudMessage.languagecode
              );
              this.actionForm.controls["messagecategory"].setValue(
                this.crudMessage.crudmessagecategoryid
              );
              if (this.crudMessage.organizationid != null) {
                this.actionForm.controls["type"].setValue("tenant");
              } else {
                this.actionForm.controls["type"].setValue("common");
              }
            }

            this.isLoading = false;
          } else {
            console.log("Error while saving");
            this.isLoading = false;
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  save() {
    if (this.actionForm.controls["message"].value.toString().trim() == "") {
      this.showWarning("Message is mandatory");
      return;
    }
    if (this.actionForm.controls["messagecategory"].value.toString().trim() == "") {
      this.showWarning("Message Category is mandatory");
      return;
    }
    if (this.actionForm.controls["type"].value.toString().trim() == "") {
      this.showWarning("Type is mandatory");
      return;
    }

    console.log("mode", this.mode);
    if(this.mode.toLowerCase() == "new"){
    if (
      this.actionForm.controls["type"].value.toLocaleLowerCase() == "common"
    ) {
      this.crudMessageId = this.guid.getGUID("commoncrudmessage");
    }   else if (
      this.actionForm.controls["type"].value.toLocaleLowerCase() == "tenant"
    ) {
      this.crudMessageId = this.guid.getGUID("tenantcrudmessage");
    }
  }

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      // profileid: userDetail.profileid,
      // profilename: userDetail.profilename,
      data: {
        crudmessage: {
          id: this.crudMessageId,
          mode: this.mode,
          message: this.actionForm.controls["message"].value.trim(),
          languagecode:
            this.actionForm.controls["language"].value.trim(),
          type: this.actionForm.controls["type"].value.trim(),
          crudmessagecategoryid:
            this.actionForm.controls["messagecategory"].value.trim(),

        },
      },
    };


    console.log(postOption);
    this.isLoading = true;
    this.dataService.upsertCrudMessage(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl("home/crudmessagelist");
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
